<template>
  <div class="drop-field">
    <v-card
        @click="dragAndDropClick"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
        :class="'drag-and-drop ' + (dragover ? 'grey lighten-2' : '')"
        elevation="0"
    >
      <v-card-text>
        <v-row class="d-flex drag-container" dense align="center" justify="center">
          <v-col class="drag-column">
            <v-icon :class="[dragover ? 'mt-2, mb-6' : 'mt-5']" size="60">
              cloud_upload
            </v-icon>
            <p>
              {{ $t('components:drag-and-drop-file.title') }}
            </p>
            <v-file-input
                ref="fileInput"
                accept="image/*, application/pdf"
                :label="$t('components:common.filename')"
                show-size
                prepend-icon=""
                truncate-length="50"
                @change="onSelect"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <DragAndDropDialog
        @onClose="clearData"
        ref="dialog"/>
  </div>
</template>
<script>

import DragAndDropDialog from '@/modules/book/views/task/dashboard-table/DragAndDropDialog';
export default {
  name: "DashboardTable",
  components: {DragAndDropDialog},
  data() {
    return {
      dragover: false
    }
  },
  methods: {
    dragAndDropClick() {
      this.$refs.fileInput.$refs.input.click();
    },
    onDrop(e) {
      if (!e) return;
      let file = e.dataTransfer.files[0];
      this.$refs.dialog.openDialog(file);
    },
    onSelect(file) {
      if (!file) return;
      this.$refs.dialog.openDialog(file);
    },
    clearData() {
      this.$refs.fileInput.clearableCallback();
    },
    updateData() {
      this.$refs.dialog.updateData();
    }
  }
}
</script>

<style lang="scss">
.task-dashboard {

  .drop-field {
    height: 100%;

    .v-file-input {
      display: none;
    }

    .drag-and-drop {
      height: 100%;

      .v-card__text {
        height: 100%;
      }
    }

    .drag-column {
      text-align: center;
    }
    .drag-container {
      height: 100%;
    }
  }

  .row .col.col-6 .ma-1 {
    margin: 0 !important;
  }
}

</style>